import {
  RecruitmentTypeEnum,
  SocialRecruitmentTypeEnum,
  CampusRecruitmentTypeEnum,
  RecruitmentMethodEnum,
  RestTypeEnum,
  WorkTypeEnum,
  OfferTransitionEnum,
  ExpectedJoinTimeEnum,
  AcceptableJobSeekerStatusEnum,
  PreferredSchoolBackgroundEnum,
  PreferredDegreeBackgroundEnum,
  PreferredWorkExperienceEnum,
} from '@/context/job-builder';

export const RECRUITMENT_SIZE_1_10 = 'rs_1_10';
export const RECRUITMENT_SIZE_10_20 = 'rs_10-20';
export const RECRUITMENT_SIZE_20_49 = 'rs_20-49';
export const RECRUITMENT_SIZE_50_99 = 'rs_50-99';
export const RECRUITMENT_SIZE_100 = 'rs_100+';

export const RECRUITMENT_SIZE_MAP: Record<string, string> = {
  [RECRUITMENT_SIZE_1_10]: '1-10人',
  [RECRUITMENT_SIZE_10_20]: '10-20人',
  [RECRUITMENT_SIZE_20_49]: '20-49人',
  [RECRUITMENT_SIZE_50_99]: '50-99人',
  [RECRUITMENT_SIZE_100]: '100人以上',
};

export const RECRUITMENT_TYPE_MAP = {
  [RecruitmentTypeEnum.Social]: '社会招聘',
  [RecruitmentTypeEnum.Campus]: '校园招聘',
};

export const SOCIAL_RECRUITMENT_TYPE_MAP = {
  [SocialRecruitmentTypeEnum.PartTime]: '兼职',
  [SocialRecruitmentTypeEnum.FullTime]: '全职',
};

export const CAMPUS_RECRUITMENT_TYPE_MAP = {
  [CampusRecruitmentTypeEnum.Internship]: '实习',
  [CampusRecruitmentTypeEnum.OnCampus]: '校招',
};

export const OFFER_TRANSITION_MAP = {
  [OfferTransitionEnum.Yes]: '提供转正',
  [OfferTransitionEnum.No]: '不提供转正',
};

export const RECRUITMENT_METHOD_MAP = {
  [RecruitmentMethodEnum.Direct]: '企业直招',
  [RecruitmentMethodEnum.Expatriate]: '外包岗位',
  [RecruitmentMethodEnum.Outsourcing]: '外派岗位',
  [RecruitmentMethodEnum.Headhunting]: '猎头岗位',
};

export const REST_TYPE_MAP = {
  [RestTypeEnum.Double]: '周末双休',
  [RestTypeEnum.Single]: '周末单休',
  [RestTypeEnum.BigSmall]: '大小周',
  [RestTypeEnum.Shift]: '轮班制',
};

export const WORK_TYPE_MAP = {
  [WorkTypeEnum.REMOTE]: '远程',
  [WorkTypeEnum.ONSITE]: '到岗',
};

export const EXPECTED_JOIN_TIME_MAP = {
  [ExpectedJoinTimeEnum.AnyTime]: '随时',
  [ExpectedJoinTimeEnum.InTwoWeeks]: '2周内',
  [ExpectedJoinTimeEnum.InOneMonth]: '1个月内',
  [ExpectedJoinTimeEnum.NoPreference]: '不限',
};

export const UNACCEPTABLE_JOBSEEKER_STATUS_MAP = {
  [AcceptableJobSeekerStatusEnum.Unemployed]: '当前离职',
  [AcceptableJobSeekerStatusEnum.Employed]: '当前在职',
  [AcceptableJobSeekerStatusEnum.EmployedWhileStudy]: '当前在职读书',
};

export const PREFERRED_SCHOOL_BACKGROUND_MAP = {
  [PreferredSchoolBackgroundEnum.Good]: '985/211',
  [PreferredSchoolBackgroundEnum.OverseasFamousSchool]: '海外名校',
  [PreferredSchoolBackgroundEnum.DoubleFirst]: '双一流',
  [PreferredSchoolBackgroundEnum.NoPreference]: '不限',
};

export const PREFERRED_DEGREE_BACKGROUND_MAP = {
  [PreferredDegreeBackgroundEnum.Doctor]: '博士',
  [PreferredDegreeBackgroundEnum.Master]: '硕士及以上',
  [PreferredDegreeBackgroundEnum.Bachelor]: '本科及以上',
  [PreferredDegreeBackgroundEnum.College]: '大专及以上',
  [PreferredDegreeBackgroundEnum.NoPreference]: '不限',
};

export const PREFERRED_WORK_EXPERIENCE_MAP = {
  [PreferredWorkExperienceEnum.LessThanOne]: '1年以下',
  [PreferredWorkExperienceEnum.OneToThree]: '1-3年',
  [PreferredWorkExperienceEnum.ThreeToFive]: '3-5年',
  [PreferredWorkExperienceEnum.FiveToTen]: '5-10年',
  [PreferredWorkExperienceEnum.MoreThanTen]: '10年以上',
};

export const CULTURE_PREFERENCE_TEXT = [
  {
    title:
      '一、请在以下描述中，各选择一个你最符合的、最不符合的本职位所在团队的工作节奏。',
    options: [
      'A. 比较独立自主，自主决定工作节奏。',
      'B. 佛系团队，舒缓的工作节奏。',
      'C. 有条不紊，严格依照预设流程按部就班的开展工作。',
      'D. 快节奏，通过快速执行以达成任务挑战目标。',
    ],
  },
  {
    title:
      '二、请在以下描述中，各选择一个你最符合的、最不符合的本职位所在团队的领导风格。',
    options: [
      'A. 团队领导注重团队在专业上的创新突破，以及团队专业能力建设。',
      'B. 团队领导注重团队的内在凝聚力，以及友善温情的团队氛围建设。',
      'C. 团队领导注重工作流程和规范建设，团队成员会得到明确的工作安排和工作指示。',
      'D. 团队领导注重行动，往往身先士卒带领成员快速行动以达成工作目标。',
    ],
  },
  {
    title:
      '三、请在以下描述中，各选择一个你最符合的、最不符合的本职位所在团队的成员相处氛围。',
    options: [
      'A. 团队注重工作与生活的平衡，团队成员保持独立性。',
      'B. 团队像一个大家庭，团队成员间能够建立长期稳定的同事关系。',
      'C. 团队像一个机器，团队成员按流程要求有条不紊开展工作并互相协作。',
      'D. 团队像一个作战小组，团队成员一起攻城掠地。',
    ],
  },
  {
    title:
      '四、请在以下描述中，各选择一个你最符合的、最不符合的本职位所在团队的工作考核方式。',
    options: [
      'A. 能否在目标工作领域内取得高质量的工作成果。',
      'B. 能否和团队组织目标保持高度统一。',
      'C. 能否按照工作流程要求精细化的开展工作。',
      'D. 能否快速达成任务目标。',
    ],
  },
  {
    title:
      '五、请在以下描述中，各选择一个你最符合、最不符合的本职位所在团队的决策模式。',
    options: [
      'A. 决策主要依据专业意见。',
      'B. 决策主要基于团队成员的一致性意见。',
      'C. 决策主要基于团队领导制定的策略。',
      'D. 决策主要基于客户需求。',
    ],
  },
  {
    title:
      '六、请在以下描述中，各选择一个你最符合的、最不符合的本职位所在团队的组织模式。',
    options: [
      'A. 扁平化团队，没有明显的成员层级。',
      'B. 团队领导和管理层级较为固定，团队成员稳定。',
      'C. 团队职级分明，通过晋升以提高话语权。',
      'D. 快速反应的小型团队，团队成员有比较快的更迭速度。',
    ],
  },
  {
    title:
      '七、请在以下描述中，各选择一个你最符合的、最不符合的本职位所在团队的成员工作成长模式。',
    options: [
      'A. 领导会关注团队成员在专业能力上的成长并帮助搭建方法论。',
      'B. 领导会关注团队成员的成长和心理建设，并尽可能为成员的个人事务提供帮助和便利。',
      'C. 领导会关注团队成员的执行成长，并提供流程化的工作方法支持。',
      'D. 领导会关注团队成员在目标达成过程中遇到的挑战并提供激励。',
    ],
  },
];
export const TEAM_TYPE_PREFERENCE_MAP = (
  mode: string,
  score: number,
): Record<string, string[]> => {
  return {
    [mode]: DEFAULT_TEAM_TYPE_PREFERENCE_MAP(score)[mode]?.map(
      (item, index) =>
        MODULE_SENTENCE(item, mode)[TEAM_TYPE_MODULE_SENTENCE[mode][index]],
    ),
  };
};

export const DEFAULT_TEAM_TYPE_PREFERENCE_MAP = (
  score: number,
): Record<string, string[]> => {
  const isShowSecondWord = score && score >= 50;
  return {
    A: [
      `工作与生活平衡，工作与生活安排不会产生${
        isShowSecondWord ? '过多' : ''
      }冲突`,
      '工作讨论中能否平等交流，决策基于专业意见而非个人喜好',
      '自身专业领域的独到见解与专业知识，以形成独特与领先的解决方案',
      '工作任务有挑战性、团队有探索精神，可以在自己的专业工作领域得到深入发展',
      `${isShowSecondWord ? '非常' : '略微'}注重成员在工作中的专业性和严谨性`,
    ],
    C: [
      `工作节奏平缓，团队成员有${isShowSecondWord ? '部分' : '较小'}外部压力`,
      `团队成员之间的工作氛围是否融洽，${
        isShowSecondWord ? '较少' : '几乎不'
      }存在公开扩大化的矛盾冲突`,
      '来自上级的温和指导，不仅能够为日常的工作提供帮助，同时也为生活提供便利性',
      `团队成员间能够有持续${
        isShowSecondWord ? '很长' : '较长'
      }时间的工作关系，日常相处中既是同事也是朋友`,
      `${isShowSecondWord ? '非常' : '较为'}强调团队成员工作目标的一致性`,
    ],
    H: [
      `任务${isShowSecondWord ? '非常' : '较为'}明确、能够按部就班的开展工作`,
      `团队管理者是否${
        isShowSecondWord ? '相当' : '较为'
      }注重细节执行，同时通过流程化的规章制度以及KPI制度对日常任务进行管理`,
      `细心严谨的态度以及${isShowSecondWord ? '显见' : '较强'}的逻辑能力`,
      '工作团队以精细化运营为导向，在工作中注重细节执行和优化',
      `工作流程化较强，团队成员普遍具有${
        isShowSecondWord ? '非常' : '十分'
      }严谨细致的工作态度`,
    ],
    M: [
      '能够通过任务达成来快速获得收益',
      '团队能否提供资源帮助团队成员达成任务',
      `${isShowSecondWord ? '' : '较强'}的行动力和冲劲，从而达成工作目标`,
      '团队领导更关注目标任务的完成进程，帮助达成目标并提供激励',
      '能够在任务完成过程中实现自我、提升自我',
    ],
    AC: [
      '成员是否具备工作探索与突破的能力，也注重成员的整体凝聚力',
      '成员工作时间较灵活，在工作任务完成前提下可自由安排时间',
      '团队工作氛围和谐友善，团队成员间人际关系简单透明',
      '工作任务有挑战性，团队成员面对工作有一致的探索精神',
      '成员有较高的“主人翁”意识，能够带动整体工作效率的提高',
      '团队注重生活与工作的平衡，成员有较强的个体性和独立性',
      '成员在工作中能够平等友善的交流',
    ],
    AM: [
      '团队对工作任务的完成质量有较高的要求，同时对达成任务所需的时间也有一定的要求',
      '成员在工作上不仅能够得到专业性的指导，而且工作中有一定的考核要求',
      '团队成员在工作中是否分工明确，在各自领域是否都有专业性的知识储备',
      '较高的薪酬激励体制与坦诚、简单、高效的沟通反馈机制',
      '对于市场变化有较强的适应力和应变能力',
      '团队面对项目时全力寻找机遇并力求突破',
      '团队在关注客户需求的前提下，更为关注自身工作的专业性探索',
    ],
    MA: [
      '团队有来自专业领域的工作项目达成支撑体系',
      '在工作开拓性探索研究的过程中，较为关注客户的真正需求',
      '团队领导者以革新方式促使任务目标的完成',
      '工作上较为严格的考核要求，同时在自身的领域也能够得到一定的提升',
      '以客户需求优先，以客户满意度为工作准则',
      '团队是否能够通过专业的方法体系达成任务目标',
    ],
    CA: [
      '团队在面对决策时以成员的统一意见优先，有时也会征询专业人士的意见',
      '成员既有较强的精神凝聚力，也能够灵活应对工作中出现的各种问题',
      '团队成员在工作时能否在明确的分工下进行密切协作',
      '团队成员遇到问题和难题时，可以充分利用团队的力量与资源',
      '成员面临较小的内部压力，犯小错误时会对员工进行口头批评等惩罚形式，原则性错误则会被严肃惩罚',
      '团队通过专业的方法共同完成统一明确的工作目标',
    ],
    CH: [
      '团队领导者既对成员进行温和的指导，也依据制度对成员进行管理',
      '成员在遵循流程化的规章制度的前提下团结、友善的开展工作',
      '团队遇到需要决策时以成员的统一意见优先，同时来自领导的意见也有很大影响力',
      '团队管理多层级且领导层较稳固，成员间能够形成长期稳定的同事关系',
      '在工作中有较强的执行力，惯于将工作流程化后执行',
      '团队的工作目标能否得到多数成员认可并共同协作',
      '团队成员间和谐、友善，彼此包容性较强',
    ],
    HC: [
      '团队面临决策时以领导的意见为主，同时也会借鉴团队成员的意见',
      '领导不但会在工作中给予成员较为温和的指导，而且注重以流程化、规范化的方式对团队成员进行管理',
      '团队成员有一致的工作目标，并以严谨细致的态度完成工作任务',
      '明确的成员奖惩的方案与管理条例以及团队对于员工生活上的帮助',
      '层级严明，有明确的晋升规则与奖励体系',
      '团队成员间能否按照管理层级与工作流程，从而建立和谐友善的工作关系',
    ],
    HM: [
      '以遵循规章制度为前提，团队成员任务目标是否能够达成',
      '层级严明，且面对工作任务有较快的应变能力',
      '团队以客户需求为先，通过较强的组织能力达成任务目标',
      '能够逐步建立体系化的问题解决方案与完整的客户信息管理体系',
      '对成员有区别化、多样化的激励机制，促使成员完成工作任务',
      '团队达成任务的标准流程化，强调任务达成的科学性',
    ],
    MH: [
      '团队面临决策时以市场的需求为核心导向',
      '以任务目标达成为前提，遵循规章制度作为团队成员的考核标准',
      '团队通过流程化的模式对日常工作任务进行管理',
      '针对不同的客户群体尝试不同的运营策略，以达成工作任务',
      '成员可以通过学习流程化的规章促使达成任务目标的达成',
      '团队成员在任务达成过程中能够养成严谨且勇于向前的精神',
      '团队有立体式的任务达成支撑体系',
    ],
    ACH: [
      '既在专业领域中有着如鱼得水的自信，也能在漫长且略带枯燥的工作中严阵以待',
      '整个团队在工作中有明确的目标，劲儿往一处使，能够以严谨的态度对待每一个工作细节',
      '氛围和谐友善，成员间人际关系简单透明',
      '在日常工作能够平等友善的交流，同时注重细节执行与优化',
      '团队成员在工作中能够养成较强的“主人翁”意识，专业的知识予以严谨的态度，从而提升工作效率',
    ],
    AMH: [
      '既有着不懈的奋进探索精神，也能够以最为严谨的态度面对遇到的困难',
      '整个团队面对工作时秉持着高标准、高效率、严要求的准则，拒绝拖拖拉拉与不负责的工作态度',
      '工作中拥有坦诚、简单、高效的沟通反馈机制，繁琐的审批流程几乎为零',
      '在完成任务的前提下，个人对工作与生活的时间把控度较为自由',
      '工作中，团队成员能够得到专业性的指导，不怕压力大，面对考核以专注严谨的准则要求自己',
    ],
    CHM: [
      '既能够得到同事及上级温和性的指导，也能够以一定的制度进行管理，不慌不忙，一步一步才是至简之道',
      '团队是一个整体，面对工作大家拧成一股绳，能够以标准的工作流程以及切实合理的时间安排去完成手中的工作',
      '成员之间有着和谐、友善的氛围，彼此之间的包容性较强',
      '日常工作中，团队成员间其乐融融，不会有过多的矛盾冲突，同时以较强的执行力来达成工作目标',
      '团队成员在工作中能够养成较强',
      '的团队合作精神，同时也能培养一定的执行力',
    ],
    CAM: [
      '团队成员既有较强的精神凝聚力，也能够灵活应对工作中出现的各种问题，大大提高了工作效率',
      '整个团队以明确分工、密切协作、高效达成目标为工作准则，而不仅仅是进行简单的例行日常工作',
      '成员间的内部竞争压力较小，专业的人负责专业的事，大家如同不可分割的一家人一样',
      '成员之间的工作氛围融洽，同事间相处友善和谐',
      '团队成员在工作中能够充分利用团队资源，以专业事实为依据，从而达到预想的工作目标',
    ],
    HCA: [
      '团队既实施流程化、规范化的管理，同时提供对团队成员较为有益的工作指导，拒绝死板教条化的管理',
      '团队有着一致的工作目标，同时以严谨细致且专业化的工作态度作为日常的工作准则',
      '层级严明，有明确的晋升规则与奖励体系，是非曲折，自在制度',
      '成员之间依据管理层级建立了和谐友善的工作关系',
      '工作中，团队成员能够培养自己的细节优化意识与团队力凝聚意识，逐步变成善分析、有条理的自己',
    ],
    HMA: [
      '团队既实施规章制度化的管理，同时也注重建立专业体系化的问题解决方案',
      '整个团队层级分明、一个萝卜一个坑，同时对于工作目标有较强的应变能力',
      '工作中，较为注重将标准流程化，同时也注重工作中的专业性与科学性',
      '面对成员有区别化、多样化的激励机制，从而促使成员尽可能高效完成工作任务',
      '团队成员能够在流程化的制度和专业性理论的支撑下，进行工作中的开拓与创新，提高了工作目标的可行性与成功性',
    ],
    MAC: [
      '团队既在工作中有着较严格的考核要求，同时也以专业的方法辅以大胆的创新，进而使得任务目标有较大的突破',
      '团队有来自专业领域的工作项目达成支撑体系',
      '在工作开拓性探索研究的过程中，秉持“客户是上帝”的原则，关注客户的真正需求',
      '成员能够在自身专业领域得到较大的提升，同事间可以较为平等的开展工作',
      '团队成员在工作目标达成的过程中不仅可以形成自己独属的方法论，同时也能够得到上级以及同事的帮助与指导',
    ],
    MHC: [
      '工作中，付出和回报成正比，既存在着高竞争、高压力，同时也可以获得高回报',
      '团队对于不同的任务目标群体，有着不同的运营策略准则，以达到最大效益化',
      '成员在工作中有着严谨、细心的特质以及直面目标的冲劲儿',
      '成员通过学习流程化的规章以及适度合作来促使任务目标的达成',
      '团队作为一个整体，将日常工作的任务通过流程化的模式进行更好的管理',
    ],
  };
};

export const MODULE_SENTENCE = (sentence: string, mode: string) => {
  if (mode.length > 1) {
    return [
      `您所在的团队${sentence}；`,
      `在工作中，您所在的团队更为注重：${sentence}；`,
      `您所在的工作团队：${sentence}；`,
      `团队员工能够从工作中收获：${sentence}；`,
      `您所在的${mode.length > 2 ? '：' : ''}${sentence}；`,
    ];
  }
  return [
    `您所在的团队${sentence}；`,
    `在工作中，您所在的团队更为注重：${sentence}；`,
    `您所在的工作团队：${sentence}；`,
    `团队员工能够从工作中收获：${sentence}；`,
    `您所在的团队：${sentence}；`,
  ];
};

export const TEAM_TYPE_MODULE_SENTENCE: Record<string, number[]> = {
  A: [0, 1, 3, 4, 2],
  C: [0, 1, 3, 4, 2],
  H: [0, 1, 3, 4, 2],
  M: [0, 1, 3, 4, 2],
  AC: [1, 0, 4, 3, 2, 4, 0],
  AM: [4, 0, 1, 3, 2, 4, 4],
  MA: [4, 0, 4, 3, 2, 1],
  CA: [4, 0, 1, 3, 2, 4],
  CH: [4, 0, 4, 3, 2, 1, 4],
  HC: [4, 0, 4, 3, 2, 1],
  HM: [1, 0, 4, 3, 2, 4],
  MH: [4, 0, 4, 1, 2, 3, 4],
  ACH: [1, 4, 0, 2, 3],
  AMH: [1, 4, 0, 2, 3],
  CHM: [1, 4, 0, 2, 3],
  CAM: [1, 4, 0, 2, 3],
  HCA: [1, 4, 0, 2, 3],
  HMA: [1, 4, 0, 2, 3],
  MAC: [1, 4, 0, 2, 3],
  MHC: [1, 4, 0, 2, 3],
};
